import { apiClient } from '../../axios';
import { fetchClient } from '../../fetch';
import { BannerParams, TypedBannerResponse } from './types';

export const getBannersApi = <T extends BannerParams>(params: T) =>
  apiClient.get<TypedBannerResponse<T>>('/v1/exchange/banners', { params: { ...params, platform: 'WEB' } });

export const fetchBannersApi = <T extends BannerParams>(params: T, acceptLanguage?: string) =>
  fetchClient.fetch<TypedBannerResponse<T>>('/v1/exchange/banners', {
    params: { ...params, platform: 'WEB' },
    headers: acceptLanguage ? { 'Accept-Language': acceptLanguage } : undefined,
    next: { tags: ['fetchBannersApi'] },
  });
